var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 23,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1088_2766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 16.9072V36.9072H40.2188V16.9072H0.21875ZM38.2188 34.9072H2.21875V18.9072H38.2188V34.9072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2187 20.9072C18.0095 20.9072 16.2188 23.5932 16.2188 26.9072C16.2188 30.2212 18.0095 32.9072 20.2187 32.9072C22.428 32.9072 24.2188 30.2212 24.2188 26.9072C24.2188 23.5932 22.428 20.9072 20.2187 20.9072ZM20.2187 30.9072C19.4034 30.9072 18.2187 29.3486 18.2187 26.9072C18.2187 24.4659 19.4034 22.9072 20.2187 22.9072C21.0341 22.9072 22.2188 24.4659 22.2188 26.9072C22.2188 29.3486 21.0341 30.9072 20.2187 30.9072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21875 23.9072C7.56211 23.9072 6.21875 25.2506 6.21875 26.9072C6.21875 28.5639 7.56211 29.9072 9.21875 29.9072C10.8754 29.9072 12.2188 28.5639 12.2188 26.9072C12.2188 25.2506 10.8754 23.9072 9.21875 23.9072ZM9.21875 27.9072C8.66742 27.9072 8.21875 27.4586 8.21875 26.9072C8.21875 26.3559 8.66742 25.9072 9.21875 25.9072C9.77008 25.9072 10.2187 26.3559 10.2187 26.9072C10.2187 27.4586 9.77008 27.9072 9.21875 27.9072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2187 23.9072C29.5621 23.9072 28.2188 25.2506 28.2188 26.9072C28.2188 28.5639 29.5621 29.9072 31.2187 29.9072C32.8754 29.9072 34.2188 28.5639 34.2188 26.9072C34.2188 25.2506 32.8754 23.9072 31.2187 23.9072ZM31.2187 27.9072C30.6674 27.9072 30.2188 27.4586 30.2188 26.9072C30.2188 26.3559 30.6674 25.9072 31.2187 25.9072C31.7701 25.9072 32.2188 26.3559 32.2188 26.9072C32.2188 27.4586 31.7701 27.9072 31.2187 27.9072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.488 7.07129L15.332 15.0713H20.0647L31.5207 9.72926L34.012 15.0713H36.2187L32.488 7.07129Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2669 5.07129L9.34961 15.0713H12.4609L21.0202 7.88926L22.4216 9.55863L24.2982 8.68324L21.2669 5.07129Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1088_2766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.21875 0.989258)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBackIcon);
export default __webpack_public_path__ + "static/media/money-back-icon.07430ef3acab7ae781c4b261ed8b50d7.svg";
export { ForwardRef as ReactComponent };